import type { ReportRecordFields } from '@tribeplatform/gql-client/graphql'
import type {
  QueryActivityLogsArgs,
  ReportRecord,
} from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getActivityLogKey } from '../../utils/keys/report.keys.js'

export const useActivityLogs = (options: {
  variables: QueryActivityLogsArgs
  fields?: ReportRecordFields
  useQueryOptions?: UseQueryOptions<ReportRecord[]>
}) => {
  const { variables, fields = 'basic', useQueryOptions } = options
  const { client } = useTribeClient()
  const activityLogKey = getActivityLogKey({ variables, fields })

  return useQuery<ReportRecord[]>(
    activityLogKey,
    () => client.report.activityLogs(variables, fields),
    useQueryOptions,
  )
}
